<script setup>
  import {ref} from "vue";

  import ComponentBreadcrumb from "@components/Breadcrumb/Breadcrumb.vue";
  import PatientsPatientAttributesData from "@pages/Patients/Components/PatientAttributesData.vue";
  import PatientsPatientContactsData from "@pages/Patients/Components/PatientContactsData.vue";
  import PatientsPatientDelete from "@pages/Patients/Components/PatientDelete.vue";
  import PatientsPatientDocuments from "@pages/Patients/Components/PatientDocuments.vue";
  import PatientsPatientMasterData from "@pages/Patients/Components/PatientMasterData.vue";
  import PatientsPatientNoteData from "@pages/Patients/Components/PatientNoteData.vue";

  defineOptions({
    name: "PagesPatientEdit",
  });

  defineProps({
    patient: {
      type: Object,
      default: null,
    },
  });

  const refPatientAttributesData = ref(null);

  function addPatientAddress() {
    refPatientAttributesData.value.$el.scrollIntoView();
    if (refPatientAttributesData.value.$el.getBoundingClientRect().top < 80) {
      const offset = 80; // offset of fixed header height
      window.scrollBy(0, -offset);
    }
    // highlight with glow animation
    refPatientAttributesData.value.$el.classList.add("animate-glow");
    setTimeout(() => {
      refPatientAttributesData.value.$el.classList.remove("animate-glow");
    }, 2000);

    // force add a patient address
    refPatientAttributesData.value.add("patientAddress");
  }
</script>

<template>
  <ComponentBreadcrumb
    class="mt-2"
    :links="[
      {
        label: 'Patienten',
        url: patient.is_fake ? $route('patients.index', {filter: 'shared-with-me'}) : $route('patients.index'),
      },
      {
        encryptedLabel: [patient.firstname, patient.lastname],
        url: $route('patients.show', {patient: patient.id}),
      },
      {
        label: 'Patienten bearbeiten',
      },
    ]"
  />

  <section>
    <div class="px-4 pt-4">
      <h2 class="text-2xl font-semibold">
        <span :data-encrypted="patient.firstname" />
        <span :data-encrypted="patient.lastname" />
        bearbeiten
      </h2>

      <p v-if="patient.is_fake">
        Dieser Patient wurde mit Ihnen geteilt, daher wurden personenbezogene Daten nicht weitergegeben.
      </p>
    </div>

    <article class="flex flex-col items-start space-y-6 p-4 lg:flex-row lg:space-y-0 lg:space-x-6">
      <!-- article::main -->
      <div class="w-full space-y-6 lg:max-w-4xl">
        <PatientsPatientMasterData :patient="patient" @add:patient-address="addPatientAddress" />

        <PatientsPatientAttributesData ref="refPatientAttributesData" :patient="patient" />

        <PatientsPatientContactsData v-if="!patient.is_fake" :patient="patient" />
      </div>

      <!-- article::aside -->
      <div class="grid grid-cols-1 gap-6 md:grid-cols-2 lg:max-w-md lg:grid-cols-1">
        <PatientsPatientNoteData :patient="patient" :test-id="getTestId()" />

        <PatientsPatientDocuments
          v-if="!patient.is_fake && $page.props.client.license.is_pro"
          :patient="patient"
          :test-id="getTestId()"
        />

        <PatientsPatientDelete
          v-if="$page.props.can.delete_patients || $page.props.can.delete_wawi_patients"
          :patient="patient"
          :test-id="getTestId()"
        />
      </div>
    </article>
  </section>
</template>
